import React from 'react';
import Badge from './Badge';
import Text from './Text';
import localeLookup from '../config/locale';
import cx from 'classnames';

const EmptyState = ({
  title = localeLookup('translations.No content'),
  subtitle,
  body,
  fullHeight,
  icon = 'wind',
}) => {
  const modifierClasses = {
    'empty-state--full-height': fullHeight,
  };
  return (
    <div className={cx('empty-state', modifierClasses)}>
      <Badge iconColor="grey" size="large" icon={icon} />
      <Text
        size="lg"
        className="empty-state__title"
        color="dark-grey"
      >
        {title}
      </Text>
      {subtitle && (
        <Text color="dark-grey">
          {subtitle}
        </Text>
      )}
      {body && (
        <Text className="empty-state__body" color="dark-grey">
          {body}
        </Text>
      )}
    </div>
  );
};

export default EmptyState;
